import { post } from '@/util/http'
// 计划活动查询页面

/**
 * 分页查询获取列表
 *
 * @param {Object} pager 通用查询分页对象
 * @param {Object} vo    接收查询参数的VO对象, 支持fuzzyText属性模糊查询
 * @return Result
 */
export const selectPageplanActivityQuery = params => post(`/plan/planActivityQuery/selectPage`, params);
/**
 * 获取年度计划附件
 */
export const findActivityAttachment = params => post(`/plan/summary/attachment/selectAll`, params);
